<template>
  <div class="auth-section">
    <div class="form-wrapper">
      <div class="form-section">
        <component-header :title="this.type"></component-header>
        <component-form
          :authType="this.type"
          v-on:submit-clicked="submit"
          v-on:forgot-clicked="forgot"
        ></component-form>
        <component-social
          v-on:facebook-connected="createFacebook"
          v-on:twitter-connected="createTwitter"
          v-on:linkedin-connected="createLinkedin"
        ></component-social>

        <div class="login-link">
          <p v-if="this.type == 'login'">
            {{$t('auth.login.link')}}
            <a
              class="underline register"
              @click.prevent="display('signup')"
            >{{$t('auth.link')}}</a>
          </p>
          <p v-else>
            {{$t('auth.signup.link')}}
            <a
              class="underline login"
              @click.prevent="display('login')"
            >{{$t('auth.link')}}</a>
          </p>
          <br/>
          <p v-if="this.type !== 'partner'">
            {{$t('auth.signup.partner')}}
            <a
              class="underline partner"
              @click.prevent="display('partner')"
            >{{$t('auth.link')}}</a>
          </p>
          <p>
            <a
              class="underline legal"
              href="/#/legal"
              target="_blank"
            >{{$t('dash.header.nav.legal')}}</a>
          </p>
        </div>
      </div>
      <img v-if="confirmRegister" src="https://ct.capterra.com/capterra_tracker.gif?vid=2157106&vkey=cacb528208ed853298cc3fe4045c7759">
    </div>
    <component-carousel :authType="this.type"></component-carousel>

    <vs-popup :title="dialog.title" :active.sync="dialog.show" class="overlay">
      <p>{{dialog.message}}</p>
    </vs-popup>
  </div>

  
</template>

<script>
import componentHeader from './Header.vue'
import componentForm from './Form.vue'
import componentCarousel from './Carousel.vue'
import componentSocial from './Social.vue'

import Auth from '../../components/mixins/Auth'
import Common from '../../components/mixins/Common'

export default {
  name: 'component-layout',

  mixins: [Auth, Common],

  components: {
    componentHeader,
    componentForm,
    componentCarousel,
    componentSocial,
  },

  data() {
    return {
      c_key: '',
      dialog: {
        show: false,
        title: 'Login',
        message: null
      },
      confirmRegister: false
    }
  },

  async mounted() {
    const { key } = this.$route.query
    if (key) this.c_key = key

    //Check confirmation mail
    let currentRoute = this.$router.currentRoute
    if(currentRoute.name == "confirm" && currentRoute.query.token !== undefined){
      this.confirmRegister = true
      this.$vs.loading({color : 'primary'})

      const { body } = await this.verify(currentRoute.query.token).catch(this.handleDialogError)
      const { success, token, user } = body
    
      this.$vs.loading.close()
    
      if (success !== true || 'error' in body) {
        return this.handleDialogError({ body })
      }

      this.goToDash({ token, user })
    }

    // Redirect to partner form register
    if (currentRoute.query['partner-register'] !== undefined && currentRoute.query['partner-register'] == "true") {
      let type = 'partner'
      this.$emit('toggle-type', type)
    }
  },

  props: {
    type: {
      type: String,
      required: true
    }
  },

  methods: {
    /**
     * Change layout content - signup/login components
     */
    display(typeForm) {
      //let type = this.type !== 'signup' ? 'signup' : 'login'
      let type = typeForm
      this.$emit('toggle-type', type)
    },

    /**
     * Go to dashboard page
     * @param {Object} params - Params to send to dash
     */
    goToDash(params) {
      localStorage.setItem('user', JSON.stringify(params.user))
      localStorage.setItem('token', params.token)
      localStorage.setItem('session_start', Date.now())
      if (!('dry' in params) || params.dry === false) {
        window.location = '/#/dash'
      }
    },

    /**
     * Submit the auth form
     * @param {Object} form - The form to format
     */
    async submit(form) {
      let { email, password, firstname, lastname, phone, trial } = form

      email = email.trim().toLowerCase()

      // Show user something happens
      this.$vs.loading({color : 'primary'})

      let partner = this.type === 'partner' ? true : false
      trial = partner ? false : trial

      // Determine context-specific data
      const [ f, fParams, ga ] = this.type === 'signup' || this.type === 'partner'
        ? [
          // Signup-specific data
          this.signup,
          [ { email, password, firstname, lastname, phone, trial, partner, locale: this.$i18n.locale }, location.search ],
          'signup'
        ] : [
          // Login-specific data
          this.login,
          [ { email, password } ],
          'login'
        ]

      this.$ga.event('auth', ga)

      const { body } = await f(...fParams).catch(this.handleDialogError)
      const { success, token, user } = body

      this.$vs.loading.close()

      if (success !== true || 'error' in body) {
        return this.handleDialogError({ body })
      }

      if(this.type !== 'signup' && this.type !== 'partner'){
        this.goToDash({ token, user })
      }
      else{
        this.$vs.dialog({
          color: 'success',
          title: 'Confirmation',
          text: this.$t(body.message),
          acceptText: "OK"
        })
      }
    },

    /**
     * Forgot password
     * @param {Object} form - The form to format
     */
    forgot(email) {
      let body = {
        email: email
      }

      this.$ga.event('auth', 'forgot-password')

      this.password(body).then(res => {
        const { success } = res.body

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            if(res.body.error) {
              this.dialog.message = res.body.error
            }
            else if (!res.body.reason) {
              this.dialog.message = res.body.statusText
            } else {
              this.dialog.title = res.body.statusText
              this.dialog.message = res.body.reason.exception
            }
          }
          //this.dialog.show = true
          this.$vs.dialog({
            color: 'error',
            title: this.dialog.title,
            text: this.$t(this.dialog.message),
            acceptText: "OK"
          })
        }
        else {
          // TO DO - display message - mail send ?
          this.$vs.dialog({
            color: 'success',
            title: this.$t('dash.notifications.password.forgot.title'),
            text: this.$t('dash.notifications.password.forgot.content'),
            acceptText: "OK"
          })
        }
      })
    },

    /**
     * Create facebook user
     * @param {Object} form - The form to format
     */
    createFacebook(form, pages) {
      let body = {
        id: form.id,
        token: form.token
      }

      this.facebook(body).then(res => {
        const { success, token, user } = res.body

        if (!success || success !== true) {
          this.dialog.title = 'Error'
          if (!res.body) {
            this.dialog.message = 'Server not responding…'
          } else {
            if (!res.body.reason) {
              this.dialog.message = res.body.statusText
            } else {
              this.dialog.title = res.body.statusText
              this.dialog.message = res.body.reason.exception
            }
          }
          this.dialog.show = true
          return
        }

        localStorage.setItem('facebook', JSON.stringify(body))
        // localStorage.setItem('facebookPages', JSON.stringify(pages))
        let params = { token: token, user: user }
        this.goToDash(params)
      })
    },

    /**
     * Create Twitter user
     * @param {Object} form - The form to format
     */
    createTwitter(data) {
      this.goToDash(data)
    },

    /**
     * Create Linkedin user
     * @param {Object} form - The form to format
     */
    createLinkedin(data) {
      this.goToDash(data)
    }
  }
}
</script>
